'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildMetadataRecord;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _toJS = require('transmute/toJS');

var _toJS2 = _interopRequireDefault(_toJS);

var _messageTypes = require('../../pubnub-message/constants/messageTypes');

var _AssignmentMessageMetadata = require('../../assignment-v1-message-metadata/records/AssignmentMessageMetadata');

var _AssignmentMessageMetadata2 = _interopRequireDefault(_AssignmentMessageMetadata);

var _AssignmentV2MessageMetadata = require('../../assignment-v2-message-metadata/records/AssignmentV2MessageMetadata');

var _AssignmentV2MessageMetadata2 = _interopRequireDefault(_AssignmentV2MessageMetadata);

var _ChatMessageMetadata = require('../../records/PubNubMessageMetadata/ChatMessageMetadata');

var _ChatMessageMetadata2 = _interopRequireDefault(_ChatMessageMetadata);

var _InitialMessageMetadata = require('../../records/PubNubMessageMetadata/InitialMessageMetadata');

var _InitialMessageMetadata2 = _interopRequireDefault(_InitialMessageMetadata);

var _JoinChannelMessageMetadata = require('../../records/PubNubMessageMetadata/JoinChannelMessageMetadata');

var _JoinChannelMessageMetadata2 = _interopRequireDefault(_JoinChannelMessageMetadata);

var _LastSeenMessageMetadata = require('../../records/PubNubMessageMetadata/LastSeenMessageMetadata');

var _LastSeenMessageMetadata2 = _interopRequireDefault(_LastSeenMessageMetadata);

var _OfflineMessageMetadata = require('../../records/PubNubMessageMetadata/OfflineMessageMetadata');

var _OfflineMessageMetadata2 = _interopRequireDefault(_OfflineMessageMetadata);

var _ConnectedAccountUpdateMetadata = require('../../records/PubNubMessageMetadata/ConnectedAccountUpdateMetadata');

var _ConnectedAccountUpdateMetadata2 = _interopRequireDefault(_ConnectedAccountUpdateMetadata);

var _UnassignmentMessageMetadata = require('../../records/PubNubMessageMetadata/UnassignmentMessageMetadata');

var _UnassignmentMessageMetadata2 = _interopRequireDefault(_UnassignmentMessageMetadata);

var _OpenThreadMetadata = require('../../records/PubNubMessageMetadata/OpenThreadMetadata');

var _OpenThreadMetadata2 = _interopRequireDefault(_OpenThreadMetadata);

var _CloseThreadMetadata = require('../../records/PubNubMessageMetadata/CloseThreadMetadata');

var _CloseThreadMetadata2 = _interopRequireDefault(_CloseThreadMetadata);

var _EmailCapturePromptMetadata = require('../../records/PubNubMessageMetadata/EmailCapturePromptMetadata');

var _EmailCapturePromptMetadata2 = _interopRequireDefault(_EmailCapturePromptMetadata);

var _EmailCaptureResponseMetadata = require('../../records/PubNubMessageMetadata/EmailCaptureResponseMetadata');

var _EmailCaptureResponseMetadata2 = _interopRequireDefault(_EmailCaptureResponseMetadata);

var _OfficeHoursMessageMetadata = require('../../records/PubNubMessageMetadata/OfficeHoursMessageMetadata');

var _OfficeHoursMessageMetadata2 = _interopRequireDefault(_OfficeHoursMessageMetadata);

var _TypicalResponseTimeMessageMetadata = require('../../records/PubNubMessageMetadata/TypicalResponseTimeMessageMetadata');

var _TypicalResponseTimeMessageMetadata2 = _interopRequireDefault(_TypicalResponseTimeMessageMetadata);

var _TypingMessageMetadata = require('../../records/PubNubMessageMetadata/TypingMessageMetadata');

var _TypingMessageMetadata2 = _interopRequireDefault(_TypingMessageMetadata);

var _EmailMessageUpdateMetadata = require('../../records/PubNubMessageMetadata/EmailMessageUpdateMetadata');

var _EmailMessageUpdateMetadata2 = _interopRequireDefault(_EmailMessageUpdateMetadata);

var _ConnectedAccountStatusUpdateMetadata = require('../../records/PubNubMessageMetadata/ConnectedAccountStatusUpdateMetadata');

var _ConnectedAccountStatusUpdateMetadata2 = _interopRequireDefault(_ConnectedAccountStatusUpdateMetadata);

var _ReadThreadMessageMetadata = require('../../read-thread-message-metadata/records/ReadThreadMessageMetadata');

var _ReadThreadMessageMetadata2 = _interopRequireDefault(_ReadThreadMessageMetadata);

var _buildFilteredChangeMetadata = require('../../filtered-change-message-metadata/operators/buildFilteredChangeMetadata');

var _buildMetadataWithRichText = require('./buildMetadataWithRichText');

var _buildMetadataWithRichText2 = _interopRequireDefault(_buildMetadataWithRichText);

var _buildEmailMetadata = require('../../email-message-metadata/operators/buildEmailMetadata');

var _buildEmailMetadata2 = _interopRequireDefault(_buildEmailMetadata);

var _buildChatRichTemplate = require('./buildChatRichTemplate');

var _buildChatRichTemplate2 = _interopRequireDefault(_buildChatRichTemplate);

var _ContactAssociationMetadata = require('../../contact-association-metadata/records/ContactAssociationMetadata');

var _ContactAssociationMetadata2 = _interopRequireDefault(_ContactAssociationMetadata);

var _CommentMessageMetadata = require('../../comment-message-metadata/records/CommentMessageMetadata');

var _CommentMessageMetadata2 = _interopRequireDefault(_CommentMessageMetadata);

var _MessagesDeletedStatusUpdateMetadata = require('../../records/PubNubMessageMetadata/MessagesDeletedStatusUpdateMetadata');

var _MessagesDeletedStatusUpdateMetadata2 = _interopRequireDefault(_MessagesDeletedStatusUpdateMetadata);

var _ThreadDeletedStatusUpdateMetadata = require('../../records/PubNubMessageMetadata/ThreadDeletedStatusUpdateMetadata');

var _ThreadDeletedStatusUpdateMetadata2 = _interopRequireDefault(_ThreadDeletedStatusUpdateMetadata);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function buildMetadataRecord(props) {
  var metadataProps = (0, _get2.default)('metadata', props);
  var type = (0, _get2.default)(_messageTypes.MESSAGE_TYPE_ID, metadataProps);

  switch (type) {
    case _messageTypes.CHAT_MESSAGE:
      return (0, _buildMetadataWithRichText2.default)(metadataProps, _ChatMessageMetadata2.default);

    case _messageTypes.INITIAL_MESSAGE:
      return (0, _buildMetadataWithRichText2.default)(metadataProps, _InitialMessageMetadata2.default);

    case _messageTypes.OFFLINE:
      return (0, _buildMetadataWithRichText2.default)(metadataProps, _OfflineMessageMetadata2.default);

    case _messageTypes.LAST_SEEN:
      return (0, _LastSeenMessageMetadata2.default)(metadataProps);

    case _messageTypes.ASSIGNMENT:
      return (0, _AssignmentMessageMetadata2.default)(metadataProps);

    case _messageTypes.ASSIGNMENT_V2:
      return new _AssignmentV2MessageMetadata2.default(metadataProps);

    case _messageTypes.JOIN_CHANNEL:
      return (0, _JoinChannelMessageMetadata2.default)(metadataProps);

    case _messageTypes.EMAIL_MESSAGE:
      return (0, _buildEmailMetadata2.default)(metadataProps);

    case _messageTypes.EMAIL_MESSAGE_UPDATE:
      return (0, _EmailMessageUpdateMetadata2.default)(metadataProps);

    case _messageTypes.CONNECTED_ACCOUNT_UPDATE:
      return (0, _ConnectedAccountUpdateMetadata2.default)(metadataProps);

    case _messageTypes.CONNECTED_ACCOUNT_STATUS_UPDATE:
      return (0, _ConnectedAccountStatusUpdateMetadata2.default)(metadataProps);

    case _messageTypes.UNASSIGNMENT:
      return (0, _UnassignmentMessageMetadata2.default)(metadataProps);

    case _messageTypes.OPEN_THREAD:
      return (0, _OpenThreadMetadata2.default)(metadataProps);

    case _messageTypes.CLOSE_THREAD:
      return (0, _CloseThreadMetadata2.default)(metadataProps);

    case _messageTypes.EMAIL_CAPTURE_PROMPT:
      return (0, _EmailCapturePromptMetadata2.default)(metadataProps);

    case _messageTypes.EMAIL_CAPTURE_RESPONSE:
      return (0, _EmailCaptureResponseMetadata2.default)(metadataProps);

    case _messageTypes.OFFICE_HOURS:
      return (0, _OfficeHoursMessageMetadata2.default)(metadataProps);

    case _messageTypes.TYPICAL_RESPONSE_TIME:
      return new _TypicalResponseTimeMessageMetadata2.default(metadataProps);

    case _messageTypes.CHAT_RICH_TEMPLATE:
      return (0, _buildChatRichTemplate2.default)(metadataProps);

    case _messageTypes.FILTERED_CHANGE:
      return (0, _buildFilteredChangeMetadata.buildFilteredChangeMetadata)(metadataProps);
    case _messageTypes.TYPING:
      return new _TypingMessageMetadata2.default(metadataProps);

    case _messageTypes.CONTACT_ASSOCIATION:
      return (0, _ContactAssociationMetadata2.default)(metadataProps);

    case _messageTypes.READ_THREAD:
      return (0, _ReadThreadMessageMetadata2.default)(metadataProps);

    case _messageTypes.THREAD_COMMENT:
      return (0, _CommentMessageMetadata2.default)(metadataProps);

    case _messageTypes.MESSAGES_DELETED_STATUS_UPDATE:
      return (0, _MessagesDeletedStatusUpdateMetadata2.default)(metadataProps);

    case _messageTypes.THREAD_DELETED_STATUS_UPDATE:
      return (0, _ThreadDeletedStatusUpdateMetadata2.default)(metadataProps);

    default:
      console.warn('NO METADATA RECORD FOR MESSAGE OF TYPE ' + type);
      window.Raven.captureMessage('MESSAGE_WITH_INVALID_TYPE: ' + type, {
        extra: (0, _toJS2.default)(props)
      });
      return null;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/factories/PubNubMessageFactory/buildMetadataRecord.js
// module id = 707
// module chunks = 2 3